export const environment = {
	production: true,
	appCode: 'villers-admin',
	appVersion: '1',
	languages: ['en', 'fr'],
	appName: 'villers',
	login: {
		redirection: [''],
	},
	logout: {
		redirection: ['session', 'sign-in'],
	},
	api: {
		uri: 'https://api.villers.appymax.com/v1',
		adminPath: '/admin',
	},
	images: {
		uri: 'https://s3.appymax.com/villers/',
	},
	plugins: {
		quickForm: {
			enabled: true,
		},
	},
};
